'use client'
import { Button } from '@/components/ui/button'
import { Suspense, useState } from 'react'
import Enter from '../_components/enter'
import FastReg from '../_components/fastreg'
import { Reset } from '../_components/reset'

export default function Auth() {
	const [register, setRegister] = useState(false)

	const [registerStatus, setRegisterStatus] = useState<
		'fastReg' | 'enter' | 'reset'
	>('enter')

	return (
		<div className='flex min-h-screen w-full items-center sm:justify-center justify-start flex-col px-4 py-6 sm:px-6 lg:px-8'>
			<div className='w-full max-w-md'>
				<Suspense>
					{registerStatus == 'enter' && <Enter />}
					{registerStatus == 'fastReg' && <FastReg />}
					{registerStatus == 'reset' && <Reset />}
				</Suspense>
				<div className='mt-6 text-center'>
					{registerStatus == 'fastReg' && (
						<p className='text-white text-sm mt-6 '>
							Есть аккаунт?{' '}
							<Button
								variant='link'
								className='underline text-white p-0 h-auto font-normal hover:text-blue-400 transition-colors'
								onClick={() => setRegisterStatus('enter')}
							>
								Войти
							</Button>
						</p>
					)}
					{(registerStatus == 'enter' || registerStatus == 'reset') && (
						<p className='text-white text-sm'>
							Еще нет аккаунта?{' '}
							<Button
								variant='link'
								className='underline text-white p-0 h-auto font-normal hover:text-blue-400 transition-colors'
								onClick={() => setRegisterStatus('fastReg')}
							>
								Зарегистрироваться
							</Button>
						</p>
					)}
					{registerStatus == 'enter' && (
						<p className='text-white text-sm text-center mt-6'>
							Забыли пароль?{' '}
							<Button
								variant='link'
								className='underline text-white p-0 h-auto font-normal hover:text-blue-400 transition-colors'
								onClick={() => setRegisterStatus('reset')}
							>
								Восстановить
							</Button>
						</p>
					)}
				</div>
			</div>
		</div>
	)
}
